const pollutionColors = [
  "#29503e",
  "#006543",
  "#007a49",
  "#00904b",
  "#00a652",
  "#33992b",
  "#50b849",
  "#fdf100",
  "#ffcb05",
  "#f9a61a",
  "#f48221",
  "#f55820",
  "#d93b20",
  "#ca252c",
  "#ca252c",
]

export default pollutionColors
